import stickerAmbos from "../images/AMBOS_v2.png";
import stickerTope from "../images/TOPE_v2.png";
import stickerCubrePolvo from "../images/CUBREPOLVO_v2.png";

// Mapea el StickerTipo que devuelve el backend (v2) a su imagen y texto alt.
// 'NINGUNO' (o cualquier valor desconocido) no tiene sticker → null.
const STICKERS = {
  AMBOS: { src: stickerAmbos, alt: "Incluye accesorios: rebote y cubre polvo" },
  TOPE: { src: stickerTope, alt: "Incluye accesorio: tope de rebote" },
  CUBREPOLVO: { src: stickerCubrePolvo, alt: "Incluye accesorio: cubre polvo" },
};

export const getAccesorioSticker = (stickerTipo) => STICKERS[stickerTipo] || null;
